import React, { useEffect, useState } from 'react';
import propTypes from 'prop-types';
import _ from 'lodash';
import StepBackBone, { useStepperController } from './step-backbone';
import SensorInputs from '../../sensor-inputs/SensorInputs';
import { useField } from 'formik';
import { Grid, Stack, Typography } from '@mui/material';
import { SensorsChart } from '../../../../../../devices';
import { useOnlineDeviceStream } from '../../../../live/online-device-provider';
import { useTranslation } from 'react-i18next';
import { sensorAlgorithm } from 'wyes-glasses-core/src/processing/sensor-current-algorithm';

export const useSensorsDatasetFromField = (namespace, dataset) => {
  const [{ value }, meta] = useField(namespace);
  const [data, setData] = useState([]);

  useEffect(() => {
    const data = [];
    _.each(value, (v) => {
      const index = _.findIndex(dataset, { key: v.n });
      const set = dataset[index];
      if (set) {
        data.push({
          noBackground: true,
          __name: set.name,
          __key: 's' + data.length,
          __uuid: set.key,
          __data: set.data,
          __compute: ((_algo) => (_scope, value) => _algo(value))(sensorAlgorithm(v)),
        });
      }
    });
    setData(data);
  }, [value, dataset, setData]);

  return { data, value };
}

export default function ChooseInputs({ namespace }) {
  const { t } = useTranslation();
  const { setNextButtonDisabled } = useStepperController();
  const [field, meta] = useField(namespace + '.i');
  const { dataset, emitter } = useOnlineDeviceStream();

  const { data } = useSensorsDatasetFromField(namespace + '.i', dataset);

  useEffect(() => {
    setNextButtonDisabled(meta.error);
  }, [meta.error, setNextButtonDisabled]);

  return (
    <StepBackBone>
      <Stack spacing={2}>
        <SensorsChart defaultStarted={true} datasets={data} emitter={emitter} height='400px' />
        <Typography variant='body2' color='text.secondary'>
          {t('MOVE_CONF.SENSOR_HELP')}
        </Typography>
        <SensorInputs namespace={namespace + '.i'} />
      </Stack>
    </StepBackBone>
  );
}

ChooseInputs.propTypes = {
  namespace: propTypes.string,
}
